// Blog posts data structure
export const blogPosts = [
  {
    id: 'top-5-night-clubs-jamshedpur-2026',
    slug: 'top-5-night-clubs-jamshedpur-2026',
    title: 'Top 5 Night Clubs in Jamshedpur (2026 Guide)',
    excerpt: 'Discover the best night clubs in Jamshedpur for 2026. From premium nightlife at Scratch Unleashed to hidden gems, this comprehensive guide covers everything you need to know about Jamshedpur\'s club scene.',
    author: 'Nightlife Team',
    publishDate: '2026-01-15',
    readTime: '8 min read',
    category: 'Nightlife Guide',
    featured: true,
    image: 'https://images.unsplash.com/photo-1566737236500-c8ac43014a67?w=800&q=80',
    keywords: 'night clubs Jamshedpur, best clubs Jamshedpur, Jamshedpur nightlife, clubbing in Jamshedpur'
  },
  {
    id: 'best-dj-nights-jamshedpur-weekly-guide',
    slug: 'best-dj-nights-jamshedpur-weekly-guide',
    title: 'Best DJ Nights in Jamshedpur – Complete Weekly Guide',
    excerpt: 'Never miss the best DJ nights in Jamshedpur. Your complete weekly guide to DJ events, music genres, and the hottest parties across the city.',
    author: 'Nightlife Team',
    publishDate: '2026-01-20',
    readTime: '7 min read',
    category: 'Events',
    featured: true,
    image: 'https://images.unsplash.com/photo-1574391884720-bbc3740c59d1?w=800&q=80',
    keywords: 'DJ nights Jamshedpur, DJ events Jamshedpur, techno night Jamshedpur, house music Jamshedpur'
  },
  {
    id: 'ultimate-guide-nightlife-jamshedpur',
    slug: 'ultimate-guide-nightlife-jamshedpur',
    title: 'Ultimate Guide to Nightlife in Jamshedpur',
    excerpt: 'The complete insider\'s guide to experiencing Jamshedpur after dark. Clubs, lounges, bars, and everything you need to know about the city\'s nightlife scene.',
    author: 'Nightlife Team',
    publishDate: '2026-01-25',
    readTime: '10 min read',
    category: 'Nightlife Guide',
    featured: true,
    image: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=800&q=80',
    keywords: 'Jamshedpur nightlife, nightlife guide Jamshedpur, bars in Jamshedpur, clubs in Jamshedpur'
  },
  {
    id: 'where-to-party-jamshedpur-saturday-night',
    slug: 'where-to-party-jamshedpur-saturday-night',
    title: 'Where to Party in Jamshedpur on Saturday Night',
    excerpt: 'Planning your Saturday night in Jamshedpur? Discover the best venues, events, and experiences for an unforgettable weekend celebration.',
    author: 'Nightlife Team',
    publishDate: '2026-02-01',
    readTime: '6 min read',
    category: 'Weekend Guide',
    featured: false,
    image: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=800&q=80',
    keywords: 'Saturday night Jamshedpur, weekend party Jamshedpur, Saturday clubs Jamshedpur'
  },
  {
    id: 'things-to-do-jamshedpur-at-night',
    slug: 'things-to-do-jamshedpur-at-night',
    title: 'Things to Do in Jamshedpur at Night',
    excerpt: 'From premium nightclubs to late-night dining, explore the best things to do in Jamshedpur after sunset. Your complete guide to evening entertainment.',
    author: 'Nightlife Team',
    publishDate: '2026-02-05',
    readTime: '9 min read',
    category: 'City Guide',
    featured: false,
    image: 'https://images.unsplash.com/photo-1519167758481-83f29da8a1c4?w=800&q=80',
    keywords: 'things to do Jamshedpur night, evening activities Jamshedpur, nightlife activities Jamshedpur'
  },
  {
    id: 'bachelor-party-jamshedpur-guide',
    slug: 'bachelor-party-jamshedpur-guide',
    title: 'Bachelor Party in Jamshedpur – Complete Guide 2026',
    excerpt: 'Planning the perfect bachelor party in Jamshedpur? From venue selection to packages, this complete guide covers everything to make the groom\'s last night unforgettable.',
    author: 'Events Team',
    publishDate: '2026-03-01',
    modifiedDate: '2026-04-01',
    readTime: '8 min read',
    category: 'Private Events',
    featured: true,
    image: 'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=800&q=80',
    keywords: 'bachelor party Jamshedpur, bachelor party venue Jamshedpur, bachelor night Jamshedpur, best bachelor party Jamshedpur, groom party Jamshedpur'
  },
  {
    id: 'ladies-night-jamshedpur-guide',
    slug: 'ladies-night-jamshedpur-guide',
    title: 'Ladies Night in Jamshedpur – Your Complete Guide',
    excerpt: 'Everything you need to know about ladies night in Jamshedpur. Best venues, safety tips, what to expect, and how to plan the perfect girls\' night out.',
    author: 'Nightlife Team',
    publishDate: '2026-03-10',
    modifiedDate: '2026-04-01',
    readTime: '7 min read',
    category: 'Ladies Night',
    featured: true,
    image: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=800&q=80',
    keywords: 'ladies night Jamshedpur, girls night out Jamshedpur, ladies free entry Jamshedpur, couple entry Jamshedpur, safe nightclub women Jamshedpur'
  },
];

export const getBlogPostBySlug = (slug) => {
  return blogPosts.find(post => post.slug === slug);
};

export const getFeaturedPosts = () => {
  return blogPosts.filter(post => post.featured);
};
